import { MonthlyCardModule } from './../monthly-card/monthly-card.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';
import { CommentCardModule } from '../comment-card/comment-card.module';
import { DonorModule } from '../donor/donor.module';
import { FbShareModule } from '../fb-share/fb-share.module';
import { InputModule } from '../input/input.module';
import { WhatsappShareModule } from '../whatsapp-share/whatsapp-share.module';
import { UpdateComponent } from './components/update/update.component';
import { DonateNowModule } from '../donate-now/donate-now.module';
import { InnerTemplaterModule } from '../inner-templater/inner-templater.module';
import { CaptchaInputModule } from '../captcha-input/captcha-input.module';
import { AskUpdateModule } from '../ask-update/ask-update.module';
import { UpdatesSocialShareModule } from '../updates-social-share/updates-social-share.module';
import { ModuleLoaderModule } from '../module-loader/module-loader.module';
import { AvatarModule } from '../avatar/avatar.module';
import { OfferCardModule } from '../offer-card/offer-card.module';
import { SipPitchCardV2Module } from '../sip-pitch-card-v2/sip-pitch-card-v2.module';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ThankyouPageTipComponent } from '../../core/thankyou-page-tip/thankyou-page-tip.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatIconModule,
    SharedModule,
    DonorModule,
    FbShareModule,
    CommentCardModule,
    WhatsappShareModule,
    InputModule,
    DonateNowModule,
    InnerTemplaterModule,
    CaptchaInputModule,
    AskUpdateModule,
    MonthlyCardModule,
    UpdatesSocialShareModule,
    ModuleLoaderModule,
    AvatarModule,
    OfferCardModule,
    SipPitchCardV2Module,
    ThankyouPageTipComponent
  ],
  declarations: [UpdateComponent],
  exports: [UpdateComponent],
  bootstrap: [UpdateComponent]
})
export class UpdateModule {
  getComponent() {
    return UpdateComponent;
  }
}
